<dx-popup
    title="Assign New Location"
    [width]="600"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [colCount]="2" style="min-height: 125px" validationGroup="mainValidationGroup">
        <dxi-form-item itemType="group">
            <dxi-form-item [label]="{ text: 'Storage Site' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="selectedStorageSite"
                        [dataSource]="storageSiteDS"
                        displayExpr="name"
                        (onValueChanged)="storageSiteChanged($event)"
                    ></dx-select-box>
                </div>
                <dxi-form-validation-rule
                    type="custom"
                    [validationCallback]="isAddressSelected"
                    message="Storage Site or Service Address Is Required"
                    [reevaluate]="true"
                >
                </dxi-form-validation-rule>
            </dxi-form-item>
        </dxi-form-item>
        <dxi-form-item itemType="group">
            <dxi-form-item [label]="{ text: 'Customer' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="selectedCustomer"
                        [dataSource]="customersDS"
                        displayExpr="displayName"
                        (onValueChanged)="customerChanged($event)"
                    ></dx-select-box>
                </div>
            </dxi-form-item>
            <dxi-form-item [label]="{ text: 'Service Address' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="selectedServiceAddress"
                        [items]="customerServiceAddresses"
                        displayExpr="displayName"
                    ></dx-select-box>
                </div>
                <dxi-form-validation-rule
                    type="custom"
                    [validationCallback]="isAddressSelected"
                    message="Storage Site or Service Address Is Required"
                    [reevaluate]="true"
                >
                </dxi-form-validation-rule>
            </dxi-form-item>
        </dxi-form-item>
    </dx-form>
</dx-popup>
